<template>
  <div class="row notranslate" id="documentBox" translate="no">
    <div ref="suggestion" class="col-xs-12 col-md-4 col-lg-3" :class="$user.isFreeTrial() ? 'hide': ''">
      <div id="suggestionsBox" :style="{width: suggestionWidth + 'px'}">
        <suggestion-box :suggestions="searchResult.suggestions" :biblio="biblio"
                        :suggestionHeight="suggestionHeight" :query="query" :factor="factor"
                        :showLimitPlan="showLimitPlan" :searchState="searchState"
                        :followedSearches.sync="followedSearches" :listId="listIdSelected" :listType="listType" />
      </div>
    </div>
    <list-idexlab v-if="!$user.isBasic()" id="experts-results" :project="project" :listType="listType" :items="searchResult.authors" :listId="listIdSelected"
                  :selected="selected" :similar="similar" :biblio="biblio" :nbResults="searchResult.nbResults"
                  :totalNbResults="searchResult.totalNbResults" :searchType="searchType" :query="query"
                  @updatePubDate="updatePubDate" @updateCountries="updateCountries"
                  :searchState="searchState" :searchCountries="searchCountries"
                  :nbSearchCompanies="nbSearchCompanies"
                  :showLimitPlan="showLimitPlan" :followedSearches.sync="followedSearches"
                  :projectsLists="[]"
                  :class="listType === 'aichat' ? 'col-sm-12 col-md-12 col-lg-12' : 'col-sm-12 col-md-8 col-lg-9'" :type="'result'"
    ></list-idexlab>
    <list-simple v-else :listType="listType" :items="searchResult.authors"
                 :nbResults="searchResult.nbResults"
                 :localExperts="searchResult.localExperts"
                 :totalNbResults="searchResult.totalNbResults" :searchType="searchType" :query="query"
                 @updatePubDate="updatePubDate" @updateCountries="updateCountries"
                 :searchState="searchState" :searchCountries="searchCountries"
                 :nbSearchCompanies="nbSearchCompanies"
                 :showLimitPlan="showLimitPlan" :followedSearches.sync="followedSearches"
                 :class="$user.isFreeTrial() ? 'col-sm-12 col-md-12 col-lg-12' : 'col-sm-12 col-md-8 col-lg-9'" :type="'result'"
    ></list-simple>
  </div>
</template>

<style>
  .top-document-header {
    color: black;
    max-height: 80px;
    padding: 10px 0;
    border-bottom: 1px solid #eaeaea;
  }

  .tab-content-search-by-name-selected .search-result-header-count-row,
  .tab-content-search-by-name-selected .search-result-header-count-row,
  .tab-content-search-by-name-selected .suggestion-item-nb,
  .tab-content-search-by-name-selected .filter-year-item-nb,
  .tab-content-search-by-name-selected .expert-list-action-li-search,
  .tab-content-search-by-name-selected .expert-list-action-li-add-similar{
    display: none;
  }

  #suggestionsBox.affix {
    z-index: 999 !important;
  }

  @media (max-width: 992px) {
    #suggestionsBox.affix {
      position: static;
    }
  }

  @media (min-width: 992px) {
    #suggestionsBox.affix {
      top: 185px;
    }
  }
</style>
<script>

import SuggestionBox from './../suggestion/SuggestionBox'
import ListIdexlab from '../ListIdexlab/ListIdexlab'
import ListSimple from '../ListIdexlab/ListSimple'

export default {
  components: {
    ListSimple,
    ListIdexlab,
    SuggestionBox},
  props: ['searchResult', 'searchState', 'listType', 'searchType', 'searchCountries', 'query', 'project', 'similar', 'selected', 'listIdSelected',
    'nbSearchCompanies', 'showLimitPlan'],
  name: 'DocumentsBox',
  data () {
    return {
      factor: 1,
      windowWidth: 0,
      windowHeight: 0,
      suggestionWidth: 0,
      suggestionHeight: 380,
      tabSelected: 'search',
      biblio: null,
      isSearhByName: false,
      followedSearches: []
    }
  },
  watch: {
    query: function (val) {
      this.getFollowedSearch()
    },
    windowHeight: function (val) {
      if (this.$user.isBasic()) {
        this.suggestionHeight = val - 320
      } else {
        this.suggestionHeight = val - 360
      }
    },
    windowWidth: function (val) {
      this.suggestionWidth = this.$refs.suggestion.clientWidth - 30
    },
    searchType: function () {
      this.isSearhByName = typeof this.searchType !== 'undefined' && this.searchType !== null && this.searchType.type === 'Name'
    },
    listIdSelected: function (listId) {
      this.getFollowedSearch()
    },
    listType: function (listType) {
      this.followedSearches = Object.assign([], this.followedSearches)
    }
  },
  methods: {
    updatePubDate: function (val) {
      this.$emit('updatePubDate', val)
      this.pubDate = val
    },
    updateCountries: function (val) {
      this.$emit('updateCountries', val)

      this.countries = val.countries
      this.companies = val.companies
    },
    setAffixSuggestion: function () {
      if (this.tabSelected === 'search') {
        $('#suggestionsBox').affix({
          offset: {
            top: () => {
              let offset = $('#documentBox').offset().top
              let searchBoxSize = $('#search-box').height()

              $('#suggestionsBox.affix').css('top', searchBoxSize + 40 + 'px')
              offset = offset - searchBoxSize - 40
              return offset
            }
          }
        })
      }
    },
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    },
    getFollowedSearch: function () {
      let url = 'follow/search/' + (this.listIdSelected !== null ? this.listIdSelected : '')

      this.axios.get(url).then((response) => {
        this.followedSearches = response.data
      }).catch((error) => {

      })
    }
  },
  mounted () {
    $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
      let target = $(e.target).attr('href') // activated tab
      switch (target) {
        case '#tab-search':
          this.tabSelected = 'search'
          break
        case '#tab-stats':
          this.tabSelected = 'stats'
          break
      }
    })
    this.setAffixSuggestion()

    window.addEventListener('resize', this.getWindowWidth)
    window.addEventListener('resize', this.getWindowHeight)

    this.getWindowWidth()
    this.getWindowHeight()

    this.$eventHub.$on('biblioSelected', (biblio) => {
      this.biblio = biblio
    })

    $('.hide-menu').click(() => {
      if (typeof this.$refs.suggestion !== 'undefined') {
        setTimeout(() => {
          this.suggestionWidth = this.$refs.suggestion.clientWidth - 30
        }, 400)
      }
    })
    this.getFollowedSearch()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  },
  computed: {
    cssProps () {
      return {
        '--search-by-name-selected': this.isSearhByName() ? 'true' : 'false'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/DocumentsBox.vue